export default "__VITE_ASSET__BJTQMfDb__"